import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';

import { Typography } from '../Typography';
import * as S from './TextArea.styles';

export const TextArea = forwardRef(({ id, label, error, ...rest }, ref) => {
	return (
		<S.Wrapper error={error}>
			{label && (
				<Typography tag="label" htmlFor={id ? `${id}` : null} id={id ? `${id}-label` : null}>
					{label}
				</Typography>
			)}
			<S.TextArea ref={ref} id={id} error={error} {...rest} />
			{error && error.message && (
				<S.FloatingWrapper>
					<Typography tag="span" variation="2">
						{error.message}
					</Typography>
				</S.FloatingWrapper>
			)}
		</S.Wrapper>
	);
});

TextArea.displayName = 'TextArea';
TextArea.propTypes = {
	id: PropTypes.string,
	placeholder: PropTypes.string,
	label: PropTypes.string,
	error: PropTypes.shape(),
};
